import { TRACK_EMAIL_CAPTURED } from '../types';
export const trackEmailCaptured = options => ({
  type: TRACK_EMAIL_CAPTURED,
  payload: options
});